import { create } from "zustand";
import { TextUsStages } from "../shared/const";
import { TextUsModalStoreProps } from "./lib/type";
import { modalBaseSlice } from "./slices/baseToggleSlice";
import { hideHeaderCloseBtn, showHeaderCloseBtn } from "./useHeaderActions";

export const useTextUsModalStore = create<TextUsModalStoreProps>(
  (set, get, api) => {
    const {
      open: openModal,
      close: closeModal,
      reset: resetModal,
      ...restSlice
    } = modalBaseSlice(set, get, api);
    return {
      ...restSlice,
      open: () => {
        openModal();
        showHeaderCloseBtn(resetModal);
      },
      close: () => {
        closeModal();
        hideHeaderCloseBtn();
      },
      reset: () => {
        resetModal();
        hideHeaderCloseBtn();
      },
      stage: TextUsStages.ContactData,
      setStage: (stage) => set(() => ({ stage })),
    };
  },
);
